<template>
  <!-- 店家swiper -->
  <v-sheet class="branches-swiper wd-px-5 wd-py-4" elevation="0" rounded>
    <div class="d-flex justify-space-between">
      <h2 class="text-h6 mb-2">{{ title }}</h2>
      <div class="swiper-btn-group d-flex">
        <v-btn
          class="swiper-button swiper-prev mr-3 pa-0"
          :class="{ hidden: disabledPrevBtn }"
          min-width="32"
          height="32"
          variant="text"
          aria-label="Prev Button"
          @click="prevSwiper"
        >
          <funnow-icon max-width="24" :image-path="'chevron-left.svg'" />
        </v-btn>
        <v-btn
          class="swiper-button swiper-next pa-0"
          :class="{ hidden: disabledNextBtn }"
          min-width="32"
          height="32"
          variant="text"
          aria-label="Next Button"
          @click="nextSwiper"
        >
          <funnow-icon max-width="24" :image-path="'chevron-right.svg'" />
        </v-btn>
      </div>
    </div>

    <div class="default-swiper__container mt-2">
      <swiper class="swiper" v-bind="swiperOption" @swiper="initSwiper" @slide-change-transition-end="onSlideChangeEnd">
        <swiper-slide v-for="(branch, idx) in items" :key="idx">
          <OtherOrNearbyBranchCard :branch="branch" :hide-rating="hideRating" :is-fun-book-v2="isFunBookV2" />
        </swiper-slide>
      </swiper>
    </div>
  </v-sheet>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'

import OtherOrNearbyBranchCard from '@/components/card/OtherOrNearbyBranchCard.vue'
import FunnowIcon from '@/components/icons/funnow-icon.vue'

export default {
  name: 'BranchSwiper',
  components: {
    Swiper,
    SwiperSlide,
    OtherOrNearbyBranchCard,
    FunnowIcon,
  },
  props: {
    title: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    hideRating: { type: Boolean, default: false },
    isFunBookV2: { type: Boolean, default: false },
  },
  setup() {
    const { swiper, disabledPrevBtn, disabledNextBtn, initSwiper, prevSwiper, nextSwiper, switchSwiperBtnStatus, onResize, onSlideChangeEnd } =
      useSwiperFactory()

    return {
      swiper,
      disabledPrevBtn,
      disabledNextBtn,
      initSwiper,
      prevSwiper,
      nextSwiper,
      switchSwiperBtnStatus,
      onResize,
      onSlideChangeEnd,
    }
  },
  data() {
    return {
      swiperOption: {
        width: 290,
        spaceBetween: 16,
        updateOnWindowResize: true,
      },
    }
  },
}
</script>

<style scoped lang="scss">
.swiper-btn-group {
  .swiper-button {
    &.hidden {
      visibility: hidden;
    }
  }
}
</style>
